module.exports = __webpack_public_path__ + "static/img/10y_1.079ed59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10y_1.jpg
// module id = akGF
// module chunks = 0